import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ApiService } from '../../api.service';
import { GlobalServices } from '../../global.services';
import { Router } from '@angular/router';

@Component({
  selector: 'app-subscription-signup-b2c',
  templateUrl: './subscription-signup-b2c.component.html',
  styleUrls: ['./subscription-signup-b2c.component.scss']
})
export class SubscriptionSignupB2cComponent implements OnInit {

  public dpmMsg: string = '';
  public mode: string = 'determinate';
  public submittedDPM: boolean = false;
  public tz = Intl.DateTimeFormat()?.resolvedOptions()?.timeZone || 'America/New_York';
  dpmForm: FormGroup;
  public questionSectionforDPM: boolean = false;
  public errorMessageForQuestionaireforDPM = null;
  private sesson_id: string = '';
  private setDefaultValues: { firstName?: string; lastName?: string; email?: string } = {};

  constructor(
    public fb: FormBuilder,
    public apiService: ApiService,
    public globalServices: GlobalServices,
    public router: Router
  ) {

    this.dpmForm = this.fb.group({
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      dpmEmail: ['', [Validators.required, Validators.email]],
      dpmPassword: ['', [Validators.required, Validators.minLength(6)]],
      dpmConfirmPassword: ['', Validators.required],
    });
  }

  get n() { return this.dpmForm.controls; }

  ngOnInit(): void {
    const currentUrl = this.router.url;
    const segments = currentUrl.split('/');
    const sub_segments = segments[2]?.split('-') || [];
    this.sesson_id = sub_segments[2];
    if (this.sesson_id) {
      this.getEmailIdByApi(this.sesson_id);
    }
  }


  getEmailIdByApi(endpoint: string): void {
    const url = `billingservice/getEmailCheckoutSession/${endpoint}`;
    this.apiService.getDatabill(url).subscribe(
      (res: any) => {
        const resEmail = typeof res === 'string' ? JSON.parse(res) : res;
        this.setDefaultValues = {
          firstName: resEmail.firstName || '',
          lastName: resEmail.lastName || '',
          email: resEmail.email || '',
        };

        this.dpmForm.patchValue({
          firstName: this.setDefaultValues.firstName,
          lastName: this.setDefaultValues.lastName,
          dpmEmail: this.setDefaultValues.email,
        });

        this.dpmForm.controls['firstName'].disable();
        this.dpmForm.controls['lastName'].disable();
        this.dpmForm.controls['dpmEmail'].disable();

      },
      (error) => {
        console.error("Error fetching data:", error);
      }
    );
  }

  submitDPM(): void {
    this.mode = 'indeterminate';
    this.submittedDPM = true;
    if (this.dpmForm.invalid) {
      this.mode = 'determinate';
      return;
    }
    const url = 'user/signup';
    const data = {
      email: this.setDefaultValues.email,
      firstName: this.setDefaultValues.firstName,
      lastName: this.setDefaultValues.lastName,
      password: this.dpmForm.value.dpmPassword,
      timezone: this.tz,
      subscriptionType: 'corporate',
      signUpFrom: 'corporate',
    };

    this.apiService.postFormData(url, this.globalServices.toFormData(data))
      .subscribe(res => {
        if (res?.success) {
          localStorage.setItem('userToken', res?.token || '');
          localStorage.setItem('userEmail', (this.setDefaultValues.email || '').toLowerCase());
          localStorage.setItem('userPass', this.dpmForm.value.dpmPassword);

          this.submitLoginDPM(this.dpmForm.value);
        } else {
          this.mode = 'determinate';
          this.dpmMsg = res?.message || 'Sign-up failed';
        }
      });
  }

  submitLoginDPM(value: any): void {
    this.mode = 'indeterminate';
    const data = {
      email: this.setDefaultValues.email,
      password: value.dpmPassword,
      type: 'normal',
    };
    const url = 'user/login';
    this.apiService.postFormData(url, data).subscribe(res => {
      if (res?.success) {
        this.questionSectionforDPM = true;
        localStorage.setItem('userToken', res.token);
        this.globalServices.postUserActivityLog({ loginFromUrl: 'free' });

        this.submitTheQuestionaireforDPM();
      }
    });
  }

  submitTheQuestionaireforDPM(): void {
    this.mode = 'indeterminate';
    const obj = {
      "wellness_interest": "improving_physical;managing_stress;wellness_travel",
      "age_group_interest": "25-34",
      "city": "Mumbai",
      "state": "Maharashtra",
      "country": "India"
    };

    this.apiService.postuserDataWithToken('user-data', obj).subscribe(
      (res: any) => {
        if (res?.status) {
          this.globalServices.postUserActivityLog({ questionaireCompleted: true });
          this.paymentDPM(this.dpmForm.value);
          this.router.navigate(['/confirmation']);
        } else {
          this.errorMessageForQuestionaireforDPM = res.message;
        }
      }
    );
  }

  paymentDPM(value) {
    this.mode = 'indeterminate';
    let url = 'billingservice/usersubscription/payment';
    let data =
    {
      "signUpFrom": "corporate",
      "vid": "",
      "timezone": "Asia/Calcutta",
      "couponCode": 'MLWB2C',
      "durtype": "yearly",
      "occurtype": "recursive",
      "uniqueKey": "my-app",
      "users": [],
      "isTrialUsed": 0,
      "isCorpCoupon": true,
      "password": value.dpmPassword
    }

    this.apiService.postbillDataWithOrWithoutToken(url, data).subscribe(
      (response) => {
        this.mode = 'determinate';
      })
  }
}
